import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// Hook
import { useAuth } from "../hooks/useAuth";

// Components
import {
  AqmarineButton,
  BlueButton,
  OrangeButton,
  YellowButton,
} from "../components/Buttons";
import { FormInput, FormSelect } from "../components/FormInput";
import MainView from "../components/MainView";

// Helper
import { checkAuth, handleUpdate } from "../helpers/authHelper";
import {
  ageOptions,
  countryOptions,
  ethnicityOptions,
  genderOptions,
  validateUpdate,
} from "../helpers/formHelper";
import { toast } from "react-toastify";

export default function ProfileDetails() {
  const navigate = useNavigate();

  const { auth } = useAuth();

  const [disabled, setDisabled] = useState(true);
  const [updateUser, setUpdateUser] = useState(true);

  const { user } = auth;

  const [name, setName] = useState(user.name);
  const [gender, setGender] = useState(user.gender);
  const [ageRange, setAgeRange] = useState(user.age_range);
  const [ethnicity, setEthnicity] = useState(user.ethnicity);
  const [country, setCountry] = useState(user.country);
  const [postcode, setPostcode] = useState(user.postcode);
  const [email, setEmail] = useState(user.email);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    let update = updateUser ? "user" : "password";
    let payload;

    payload = updateUser
      ? {
          name: name,
          gender: gender,
          age_range: ageRange,
          ethnicity: ethnicity,
          country: country,
          postcode: postcode,
          email: email,
        }
      : {
          new_password: newPassword,
          old_password: oldPassword,
          conf_password: confirmPassword,
        };

    let isValid = validateUpdate(payload, update);

    if (isValid) {
      // Clear form
      setName("");
      setGender("");
      setAgeRange("");
      setEthnicity("");
      setCountry("");
      setPostcode("");
      setEmail("");
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");

      // Handle Sign Up
      handleUpdate(navigate, payload, navigate, update);
    }
  };

  return (
    <MainView>
      <div className="mt-5 px-[5vw] 2xl:px-[15vw]">
        <div className="mb-5">
          <form id="updateForm" onSubmit={(e) => handleSubmit(e)}>
            <div className="flex flex-col">
              <div className="">
                <div className="my-5 md:w-[40%] mx-auto">
                  {updateUser ? (
                    <AqmarineButton
                      type="button"
                      onClick={() => {
                        if (!checkAuth(auth.token).access_token_expired) {
                          setUpdateUser(false);
                        } else {
                          toast.info("Login again to edit");
                        }
                      }}
                    >
                      Update Password
                    </AqmarineButton>
                  ) : (
                    <OrangeButton
                      type="button"
                      onClick={() => {
                        if (!checkAuth(auth.token).access_token_expired) {
                          setUpdateUser(true);
                        } else {
                          toast.info("Login again to edit");
                        }
                      }}
                    >
                      Update User
                    </OrangeButton>
                  )}
                </div>
              </div>

              {updateUser ? (
                <div className="flex flex-col-reverse sm:flex-row sm:justify-between">
                  <div className="sm:w-[48%]">
                    <div className="mb-3 sm:w-[90%] xl:w-[80%]">
                      <FormInput
                        label="Name"
                        type="text"
                        id="name"
                        disabled={disabled}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>

                    <div className="mb-3 sm:w-[90%] xl:w-[80%]">
                      <FormSelect
                        label="Gender"
                        options={genderOptions}
                        id="gender"
                        disabled={disabled}
                        value={gender}
                        onChange={(inputValue) => setGender(inputValue)}
                      />
                    </div>

                    <div className="mb-3 sm:w-[90%] xl:w-[80%]">
                      <FormSelect
                        label="Age Range"
                        options={ageOptions}
                        id="age_range"
                        disabled={disabled}
                        value={ageRange}
                        onChange={(inputValue) => setAgeRange(inputValue)}
                      />
                    </div>

                    <div className="mb-3 sm:w-[90%] xl:w-[80%]">
                      <FormSelect
                        label="Ethicity"
                        options={ethnicityOptions}
                        id="ethnicity"
                        disabled={disabled}
                        value={ethnicity}
                        onChange={(inputValue) => setEthnicity(inputValue)}
                      />
                    </div>

                    <div className="mb-3 sm:w-[90%] xl:w-[80%]">
                      <FormSelect
                        label="Country"
                        options={countryOptions}
                        id="country"
                        disabled={disabled}
                        value={country}
                        onChange={(inputValue) => setCountry(inputValue)}
                      />
                    </div>

                    <div className="mb-3 sm:w-[90%] xl:w-[80%]">
                      <FormInput
                        label="Postcode"
                        type="text"
                        id="postcode"
                        disabled={disabled}
                        value={postcode}
                        onChange={(e) => setPostcode(e.target.value)}
                      />
                    </div>

                    <div className="mb-3 sm:w-[90%] xl:w-[80%]">
                      <FormInput
                        label="Email"
                        type="email"
                        id="email"
                        disabled={disabled}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="flex flex-col">
                  <div className="sm:w-[60%] md:w-[48%]">
                    <div className="mb-4 sm:w-[100%] md:w-[90%] xl:w-[80%]">
                      <FormInput
                        label="Old Password"
                        type="password"
                        id="old_password"
                        disabled={disabled}
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="sm:w-[60%] md:w-[48%]">
                    <div className="mb-4 sm:w-[100%] md:w-[90%] xl:w-[80%]">
                      <FormInput
                        label="New Password"
                        type="password"
                        id="new_password"
                        disabled={disabled}
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="sm:w-[60%] md:w-[48%]">
                    <div className="mb-4 sm:w-[100%] md:w-[90%] xl:w-[80%]">
                      <FormInput
                        label="Confirm Password"
                        type="password"
                        id="conf_password"
                        disabled={disabled}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              )}

              <div className="">
                <div className="my-5 md:w-[40%] mx-auto">
                  {disabled ? (
                    <BlueButton
                      type="button"
                      onClick={() => {
                        if (!checkAuth(auth.token).access_token_expired) {
                          setDisabled(false);
                        } else {
                          toast.info("Login again to edit");
                        }
                      }}
                    >
                      Edit
                    </BlueButton>
                  ) : (
                    <YellowButton type="submit">Update</YellowButton>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </MainView>
  );
}
